<groundworks-modal>
  <app-paginated-modal-header [title]="title" (closed)="cancel()" />
  <groundworks-modal-body>
    <form [formGroup]="form">
      <div class="mb-3">
        <label class="form-label" for="paymentType">Payment Type <span class="text-danger">*</span></label>
        <ng-select
          id="paymentType"
          formControlName="paymentType"
          [items]="paymentMethods()"
          bindLabel="name"
          placeholder="Select payment type"
        ></ng-select>
      </div>
      @if (isCheck()) {
        <div class="mb-3">
          <label class="form-label" for="checkNumber">Check Number <span class="text-danger">*</span></label>
          <input
            id="checkNumber"
            type="text"
            class="form-control"
            placeholder="Enter check number"
            formControlName="checkNumber"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="checkAmount">Check Amount <span class="text-danger">*</span></label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="checkAmount"
              type="text"
              inputmode="decimal"
              class="form-control text-end"
              placeholder="0.00"
              formControlName="paymentAmount"
              [class.is-invalid]="form.controls['paymentAmount'].touched && form.controls['paymentAmount'].invalid"
              (blur)="onPaymentAmountBlur()"
            />
          </div>
          @if (form.controls['paymentAmount'].touched && form.controls['paymentAmount'].invalid) {
            <div class="invalid-feedback d-block text-end">{{ paymentAmountErrorMessage() }}</div>
          }
        </div>
        <div class="mb-3">
          <label class="form-label" for="checkPaymentDate">Payment Date <span class="text-danger">*</span></label>
          <div class="position-relative">
            <input
              id="checkPaymentDate"
              type="text"
              readonly
              class="form-control pe-4"
              [value]="formatDateForDisplay(form.value.paymentDate)"
              placeholder="Select date"
              [style.cursor]="'pointer'"
              (click)="togglePaymentDatePicker()"
            />
            <button
              type="button"
              class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
              aria-label="Toggle payment date picker"
              (click)="togglePaymentDatePicker()"
            >
              <i class="bi bi-calendar-check"></i>
            </button>
            @if (showPaymentDatePicker()) {
              <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
                <groundworks-date-picker
                  [isRangeSelection]="false"
                  [displayMonths]="1"
                  [minDate]="paymentDateMin()"
                  [maxDate]="paymentDateMax()"
                  [selectedDate]="paymentDateAsDate()"
                  (fromDateEvent)="handlePaymentDateSelected($event)"
                />
              </div>
            }
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="checkNotes">Notes</label>
          <textarea
            id="checkNotes"
            class="form-control"
            rows="2"
            placeholder="Enter note for this payment."
            formControlName="notes"
          ></textarea>
        </div>
      }
      @else if (isMethodSelected()) {
        <div class="mb-3">
          <label class="form-label" for="paymentAmount">Payment Amount <span class="text-danger">*</span></label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="paymentAmount"
              type="text"
              inputmode="decimal"
              class="form-control text-end"
              placeholder="0.00"
              formControlName="paymentAmount"
              [class.is-invalid]="form.controls['paymentAmount'].touched && form.controls['paymentAmount'].invalid"
              (blur)="onPaymentAmountBlur()"
            />
          </div>
          @if (form.controls['paymentAmount'].touched && form.controls['paymentAmount'].invalid) {
            <div class="invalid-feedback d-block text-end">{{ paymentAmountErrorMessage() }}</div>
          }
        </div>
        <div class="mb-3">
          <label class="form-label" for="paymentDate">Payment Date <span class="text-danger">*</span></label>
          <div class="position-relative">
            <input
              id="paymentDate"
              type="text"
              readonly
              class="form-control pe-4"
              [value]="formatDateForDisplay(form.value.paymentDate)"
              placeholder="Select date"
              [style.cursor]="'pointer'"
              (click)="togglePaymentDatePicker()"
            />
            <button
              type="button"
              class="btn btn-sm p-0 border-0 position-absolute top-50 end-0 translate-middle-y me-3"
              aria-label="Toggle payment date picker"
              (click)="togglePaymentDatePicker()"
            >
              <i class="bi bi-calendar-check"></i>
            </button>
            @if (showPaymentDatePicker()) {
              <div class="position-absolute top-100 start-0 mt-1 bg-white border rounded shadow-lg z-1000">
                <groundworks-date-picker
                  [isRangeSelection]="false"
                  [displayMonths]="1"
                  [minDate]="paymentDateMin()"
                  [maxDate]="paymentDateMax()"
                  [selectedDate]="paymentDateAsDate()"
                  (fromDateEvent)="handlePaymentDateSelected($event)"
                />
              </div>
            }
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="financingPlanNotes">Notes</label>
          <textarea
            id="financingPlanNotes"
            class="form-control"
            rows="2"
            placeholder="Enter note for this payment."
            formControlName="notes"
          ></textarea>
        </div>
      }
      @if (errorMessage()) {
        <div class="text-danger small mt-3">{{ errorMessage() }}</div>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
